import { Pipe, PipeTransform } from "@angular/core";
import { CancellationPipesService } from "./cancellation-pipes.service";

@Pipe({
    name: 'isFuture'
})
export class IsFuturPipe implements PipeTransform {

    constructor(
        private readonly cancellationPipesService: CancellationPipesService,
    ) {
    }

    public transform(date: string): boolean {
        return this.cancellationPipesService.isFuture(date);
    }

}